import { IUserWizard } from '@/modules/admin/workflows/types/wizard-types'
import { createQuery } from '../api/query'
import { TemplateType } from './types'

export const keyTemplates = [`/templates`]
export const useQueryTemplates = createQuery<TemplateType[]>({
    key: keyTemplates,
    url: '/templates',
})

/** ALO-specific Robo Interview templates (commzone_code=hypothesis-alo, enable_interviewer=true). */
export const keyAloTemplates = (params?: string) => [`/templates`, params ?? '']
export const useQueryAloTemplates = createQuery<TemplateType[] | { data?: TemplateType[] }>({
    key: (queryParams) => keyAloTemplates(queryParams ? `alo-${queryParams}` : 'alo'),
    url: '/templates',
})

export const keyCustomTemplates = [`/custom-templates`]
export const useQueryCustomTemplates = createQuery<TemplateType[]>({
    key: keyCustomTemplates,
    url: '/custom-templates',
})

export const keyTemplate = (arg: string) => [`/template`, arg]
export const useQueryTemplate = createQuery<TemplateType>({
    key: keyTemplate,
    url: '/template',
})

const keyHomeTemplates = [`/home-templates`]
export const useQueryHomeTemplates = createQuery<{
    featured: TemplateType[]
    interviews: TemplateType[]
}>({
    key: keyHomeTemplates,
    url: '/home-templates',
})

const keyUserWizard = [`/user-wizard`]
export const useQueryUserWizard = createQuery<IUserWizard>({
    key: keyUserWizard,
    url: '/user-wizard',
})
